<script>
    import Button from "./Button.svelte";
    import { MODS } from "./routes";
    export let setRoute;
    let selectedUnit;
    let selectedCard;
    let UNITS = "UNITS";
    let SPELLS = "SPELLS";
    let page = SPELLS;
    function setPage(p) {
        page = p;
    }
    // Copied from src/entity/Unit.ts
    function getExplainPathForUnitId(id) {
        return "images/explain/units/" + id.split(" ").join("") + ".gif";
    }
    // Copied from src/graphics/ui/cardUI
    function getSpellThumbnailPath(path) {
        if (!path) {
            return "";
        }
        // spellmasons-mods/ should not have anything appended to the front since
        // they are included in the mod folder
        if (path.indexOf("spellmasons-mods/") !== -1) {
            return path;
        }
        // The presence of '/' means that it's a different path than default (such as in a mod) and it isn't
        // nested in images/spell/
        return path.indexOf("/") !== -1 ? path : "images/spell/" + path;
    }
</script>

<div class="flex height100">
    <main>
        <div class="flex align-items-center gap-20" style="color:white;">
            <Button
                on:click={() => window.goBack()}
                type="button"
                text="🠔 Back"
                class="sm"
            />
            <h1 class="aside-title">{globalThis.i18n("Codex")}</h1>
        </div>
        <div id="inventory-container">
            <div id="leftpage">
                <!-- <div class="flex" style="gap:16px;">
                    <Button
                        isActive={page == UNITS}
                        on:click={() => setPage(UNITS)}
                        text="Monsters"
                        class="justify-center"
                    />
                    <Button
                        isActive={page == SPELLS}
                        on:click={() => setPage(SPELLS)}
                        text="Spells"
                        class="justify-center"
                    />
                </div> -->
                {#if page == UNITS}
                    <div class="content">
                        {#each Object.values(globalThis.allUnits).sort((a, b) => (a.spawnParams ? a.spawnParams.budgetCost : 1000) - (b.spawnParams ? b.spawnParams.budgetCost : 1000)) as unit}
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <div
                                class="square"
                                on:click={() => {
                                    selectedUnit = unit;
                                }}
                            >
                                <img
                                    src={"images/spell/spellIconSummon_" +
                                        unit.id
                                            .replaceAll(" ", "")
                                            .toLowerCase() +
                                        ".png"}
                                    alt={unit.id}
                                    onerror="this.style.display='none';"
                                    width="64"
                                    height="64"
                                />
                                <div class="label">
                                    <div class="label-inner">
                                        {unit.id}
                                    </div>
                                </div>
                            </div>
                        {/each}
                    </div>
                {:else}
                    {#each Object.entries(globalThis.CardCategory) as [index, category]}
                        {#if typeof category == "string"}
                            <h1>{globalThis.i18n(category.toString())}</h1>
                            <div class="content">
                                {#each Object.values(globalThis.allCards).filter((c) => c.category == index) as card}
                                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                                    <div
                                        class="square"
                                        on:mouseleave={() => {
                                            selectedCard = null;
                                            const elCardInspect =
                                                document.getElementById(
                                                    "card-inspect",
                                                );
                                            elCardInspect.innerHTML = "";
                                        }}
                                        on:mouseenter={() => {
                                            selectedCard = card;
                                            const hideAsUnknown = !(
                                                globalThis.spellsDiscovered &&
                                                globalThis.spellsDiscovered.includes(
                                                    card.id,
                                                )
                                            );
                                            const el =
                                                globalThis.createCardElement(
                                                    selectedCard,
                                                    undefined,
                                                    true,
                                                    hideAsUnknown,
                                                );
                                            const elCardInspect =
                                                document.getElementById(
                                                    "card-inspect",
                                                );
                                            elCardInspect.innerHTML = "";
                                            elCardInspect.appendChild(el);
                                        }}
                                    >
                                        <img
                                            src={getSpellThumbnailPath(
                                                globalThis.spellsDiscovered
                                                    ? globalThis.spellsDiscovered.includes(
                                                          card.id,
                                                      )
                                                        ? card.thumbnail
                                                        : "unknown.png"
                                                    : "unknown.png",
                                            )}
                                            alt={card.id}
                                            width="64"
                                            height="64"
                                        />
                                        <div class="label">
                                            <div class="label-inner">
                                                {globalThis.spellsDiscovered
                                                    ? globalThis.spellsDiscovered.includes(
                                                          card.id,
                                                      )
                                                        ? globalThis.i18n(
                                                              card.id,
                                                          )
                                                        : "Unknown"
                                                    : "Unknown"}
                                            </div>
                                        </div>
                                    </div>
                                {/each}
                            </div>
                        {/if}
                    {/each}
                {/if}
            </div>
            <div id="rightpage">
                {#if page == UNITS}
                    {#if selectedUnit}
                        <div>
                            <img
                                src={getExplainPathForUnitId(selectedUnit.id)}
                                onerror="this.style.display='none';"
                                alt="Unit gif"
                            />
                            <h1>{globalThis.i18n(selectedUnit.id)}</h1>
                            <hr />
                            <div>
                                {globalThis.i18n(selectedUnit.info.description)}
                            </div>
                        </div>
                    {/if}
                {:else}
                    <div id="card-inspect" class="card-inspect" />
                {/if}
            </div>
        </div>
        <div
            style="pointer-events:none;text-align:center;margin:16px;position:absolute;bottom:8px;left:0;right:0;text-shadow: 1px 1px 2px black;"
        >
            <div style="color:white;margin-bottom:8px;">
                {globalThis.i18n("Find even more spells in the mods!")}
            </div>
            <div>
                <Button
                    on:click={() => setRoute(MODS)}
                    text="Mods"
                    class="justify-center sm pointer-events--all"
                />
            </div>
        </div>
    </main>
</div>

<style>
    main {
        width: 100%;
        color: black;
        /*  Ensures the book can't grow too large */
        max-width: 1872px;
        /* Ensures the book's padding stops growing when the book stops growing*/
        position: relative;
        margin: 0 auto;
    }
    #inventory-container {
        width: 100%;
        height: unset;
        display: flex;
        gap: 10%;
        padding: 3% 10%;
        background-repeat: no-repeat;
    }
    /* Custom scrollbar for inventory */
    #leftpage::-webkit-scrollbar {
        width: 0.5em;
        cursor: pointer;
    }

    #leftpage::-webkit-scrollbar-thumb {
        background-color: var(--book-leather-light);
        border-radius: 5px;
        outline: 1px solid var(--book-leather-dark);
    }
    #leftpage {
        width: 100%;
        height: 100%;
        padding: 16px;
        box-sizing: border-box;
        justify-content: center;
        overflow-y: auto;
    }
    #leftpage .content {
        display: flex;
        flex-wrap: wrap;
        display: flex;
    }
    .square {
        width: 80px;
        cursor: pointer;
        padding: 8px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        text-align: center;
    }
    .label {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .label-inner {
        /* white-space: nowrap; */
        margin: auto;
        text-transform: capitalize;
    }
    .square img {
        margin: 0 auto;
    }
    .square:hover {
        background-color: rgba(0, 0, 0, 0.1);
    }
    #rightpage {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        color: black;
    }
    #rightpage img {
        width: 100%;
    }
    #rightpage #card-inspect {
        width: 100%;
        height: 100%;
        justify-content: center;
    }
</style>
